export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.5 3.5a1 1 0 011 1v15a1 1 0 01-1 1h-17a1 1 0 01-1-1v-15a1 1 0 011-1h17zm-16 15h15v-13h-15v13z\" fill=\"#7B61FF\"/><path d=\"M11.176 7.6h1.692l1.38 5.628 1.38-5.628h2.028l-2.292 8.616h-1.932l-1.44-5.508-1.416 5.508H8.644L6.34 7.6h2.076l1.392 5.628L11.176 7.6z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};